export default {
	name: "select-delivery-orders-for-scheduling",
	data() {
		return {
			deliveryOrders: [],
			deliveryOrdersHeadings: [
				{
					text: "Order #",
					field: "orderId"
				},
				{
					text: "Customer",
					field: "registeredCompanyName"
				},
				{
					text: "Order Date",
					field: "insertedOn"
				},
				{
					text: "Expected Date Of Delivery",
					field: "expectedDeliveryDate"
				},
				{
					text: "Customer Purchase Order Number",
					field: "customerPurchaseOrder"
				},
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Quantity",
					field: "quantity"
				},
				{
					text: "Total",
					field: "totalAsString"
				},
				{
					text: "Status",
					field: "description"
				}
			],
			selectedOrders: [],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			loading: false,
			ordersToScheduleErrorMessage:{
				message: "Please select at least one order to schedule",
				showErrorMessage: false
			},
			expectedDateOfDelivery: null,
			initialiseDate: true
		};
	},
	methods: {
		getOrders(){
			this.loading = true;
			this.selectedOrders = localStorageCacheHelper.getSelectedDeliveryOrdersForScheduling();
			orderService.getDeliveryOrdersForScheduling(this.pagingDetails.pageNumber, this.pagingDetails.pageSize, this.expectedDateOfDelivery).then(
				successfulResponse => {
					this.deliveryOrders = successfulResponse.data.result;
					if(successfulResponse.data.pagingInfo !== null) {
						this.pagingDetails.pageNumber = successfulResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successfulResponse.data.pagingInfo.totalPages;
					}
					
					console.log("pagingDetails", this.pagingDetails);

					this.deliveryOrders = dataTableHelper.castFieldValues(this.deliveryOrders);
					
					for (let i = 0; i < this.deliveryOrders.length; i++) {
						if(this.deliveryOrders[i].discountedAmount !== null){
							this.deliveryOrders[i].totalAmount = this.deliveryOrders[i].totalAmount - this.deliveryOrders[i].discountedAmount;
						}
						this.deliveryOrders[i].totalAsString = currencyHelper.numberToCurrency(this.deliveryOrders[i].totalAmount);
						this.deliveryOrders[i].selectedForScheduling = this.selectedOrders.some(order => order.orderId === this.deliveryOrders[i].orderId);
					}

					
					console.log("deliveryOrders", this.deliveryOrders);
					
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			)
		},
		onPagingUpdated(pagingInfo){
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getOrders();
		},
		onExpectedDateOfDeliverySelect(date){
			// if(this.expectedDateOfDelivery !== date){
			// 	this.expectedDateOfDelivery = date;
			// 	this.getOrders();
			// }
			this.initialiseDate = false;
			this.expectedDateOfDelivery = date;
			this.getOrders();
		},
		onOrderSelect(orderId, selected){
			console.log("selected", selected);
			var selectedOrder = this.deliveryOrders.find(order => order.orderId === orderId);
			selectedOrder.selectedForScheduling = !selectedOrder.selectedForScheduling;
			console.log("selectedOrder", selectedOrder);
			if(this.selectedOrders.some(order => order.orderId === orderId) && !selectedOrder.selectedForScheduling){
				this.selectedOrders = this.selectedOrders.filter(order => order.orderId !== orderId);
			}
			else{
				this.selectedOrders.push(selectedOrder);
			}
			console.log("selectedOrders", this.selectedOrders);
		},
		onScheduleOrdersButtonClick(){
			console.log("selectedOrders", this.selectedOrders);
			if(this.selectedOrders === null || this.selectedOrders.length === 0){
				this.ordersToScheduleErrorMessage.showErrorMessage = true;
			}
			else{
				this.ordersToScheduleErrorMessage.showErrorMessage = false;
				localStorageCacheHelper.cacheSelectedDeliveryOrdersForScheduling(this.selectedOrders);
				this.$router.push("/orders/delivery/sequenceDeliveryOrdersForDelivery");
			}
		},
		setBreadcrumbs() {
			var pageTitle = "Orders Delivery - Select Orders To Schedule";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		//this.getOrders();
		var self = this;
		setTimeout(function () {
			self.expectedDateOfDelivery = new Date();
		}, 500)
	}
};